<template>
	<div id="date" class="container-fluid" >
		<div class="container">
			<div class="row">
				<div class="col text-center">
					<h2>Dates</h2>
					<div class="divider-c"> <span></span></div>
				</div>
			</div>
		</div>
		<table class="table-date-page"> <!-- Date - Lieu/Ville - Commentaire - Google map -->
			<tbody>
				<tr
				v-for="dates in info"
				:key="dates.id"
				>
					<td class="date-col" width="15%"><span class="date-number">{{ dates.dateN }}</span> <span class="date-day">{{ dates.dateD }}</span> <span class="date-month">{{ dates.dateM }}</span></td>
					<td class="location-col align-middle" width="60%"><span>{{ dates.ville }} ({{ dates.cp }})</span></td>
					<td class="comments-col align-middle" width="15%"><span>{{ dates.commentaire }}</span></td>
					<td class="align-middle" width="10%"><a v-bind:href="'https://www.google.fr/maps/place/'+ dates.cp + '+' + dates.ville" class="btn" target="_blank"><span class="btn-text">Map</span></a></td>
				</tr>
			</tbody>
		</table>

		<div class="table-date-page-mobile">
			<div class="dates-mobile"
				v-for="dates in info"
				:key="dates.id"
			>
				<div class="head-date-mobile">
					<span class="date-mobile">{{ dates.dateN }}<br></span>
					<span class="day-mobile">{{ dates.dateD }}</span>
					<span class="month-mobile">{{ dates.dateM }}</span>
				</div>
				<div class="place-mobile">
					<span class="city-mobile">{{ dates.ville }}</span> (<span class="cp_mobile">{{ dates.cp }}</span>)
				</div>
				<div class="comment-mobile">
					<span>{{ dates.commentaire }}</span>
				</div>
				<div class="map-mobile">
					<div class="text-center">
						<a v-bind:href="'https://www.google.fr/maps/place/'+ dates.cp + '+' + dates.ville" class="btn" target="_blank"><span class="btn-text">Map</span></a>
					</div>
				</div>
			</div>
		</div>



	</div>
</template>

<script>
import axios from 'axios';

export default {
    name: 'Dates',
	data () {
		return {
			info: null,
			url_admin: process.env.VUE_APP_ADMIN_URL,
		}
	},
	mounted () {
		axios
		.get(process.env.VUE_APP_API_URL+'/getDates')
		.then(response => (this.info = response.data.data))
	}
}
</script>